// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__la5xX","label":"Section_label__239yO","contentWrap":"Section_contentWrap__3Maqi","footer":"Section_footer__k-hH6","footerInner":"Section_footerInner__2wOoI"};